// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "dist-" + chunkId + "." + "92cffd8cbf055b1475bd" + ".css";
};